import React, { useState } from 'react'

// default role type
import { role } from '../utility/defaultData';
import { superAdminRole } from '../utility/defaultData';
import { AggregatorRole } from '../utility/defaultData';

// redux 
import { useSelector, shallowEqual } from "react-redux";
import { RootState } from "../../setup/redux/RootReducer";

export const useUserRole = () => {

    let hanayUser = false
    let superAdmin = false
    let aggregatorUser = false

    const userData: any = useSelector<RootState>(
        ({ auth }) => auth?.user,
         shallowEqual
      );
    
    const {role_id} = userData?.data?.role || {}

    if(Array.isArray(role) && Array.isArray(superAdminRole) && Array.isArray(AggregatorRole)){
      
        hanayUser = [...role].some(
          (item: any) => item?.value === role_id
        );
       
        superAdmin = [...superAdminRole].some(
          (item: any) => item?.value === role_id
        ); 
        
        aggregatorUser = [...AggregatorRole].some(
          (item: any) => item?.value === role_id
        ); 

     }
   
    return [superAdmin,hanayUser,aggregatorUser];
}


